import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

// Helper to strip HTML tags
const stripHtml = (html) => html.replace(/<[^>]*>?/gm, "");

// Helper to safely truncate plain text
const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.slice(0, limit);
};


const imageMap = [
  {
    image_black: "/assets/images/mist/vision-black-icon.png",
    image_white: "/assets/images/mist/vision-white-icon.png",
  },
  {
    image_black: "/assets/images/mist/mission-black-icon.png",
    image_white: "/assets/images/mist/mission-white-icon.png",
  },
  {
    image_black: "/assets/images/mist/value-black-icon.png",
    image_white: "/assets/images/mist/value-white-icon.png",
  },
];


function MinimalIconVisionMissionValue({
  principles,
  siteType,
  defaultHeadings = ["Vision:", "Mission:", "Values:"],
}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState({});
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const CHAR_LIMIT = 70;

  if (!principles?.length || siteType !== "hospitals") return null;

  const handleReadMore = (data) => {
    setSelectedContent(data);
    setShowModal(true);
  };

  const renderContentBox = (data, index, isMobile = false) => {
    const fullDescription = data?.description || "No Description Found";
    const plainText = stripHtml(fullDescription);
    const isTruncated = plainText.length > CHAR_LIMIT;

    const truncatedText = isTruncated
      ? truncateText(plainText, CHAR_LIMIT)
      : plainText;

    const combinedHTML = isTruncated
      ? `${truncatedText}... <span class='theme-color fw-bold' style='cursor:pointer;' data-index='${index}'>Read More</span>`
      : fullDescription;


    // const isMobiless = typeof window !== "undefined" && window.innerWidth < 768;

const imageSrc = isMobile
  ? imageMap[index]?.image_black
  : hoveredIndex === index
    ? imageMap[index]?.image_white
    : imageMap[index]?.image_black;



    return (
      <div
        className={`feature-box-wrap f-box-style-2 text-center mt-3 mb-4 ${isMobile ? "relative" : "animated fadeInDown relative"
          }`}
      onMouseEnter={() => !isMobile && setHoveredIndex(index)}
onMouseLeave={() => !isMobile && setHoveredIndex(null)}

      >
        <div className="feature-box-details mission-feature-box-details minimal-icon-vision-mision-img ">
          <div className="feature-icon margin-bottom-20 mission- ">
            {imageSrc ? (
              <img
                src={imageSrc}
                alt=""
                style={{ width: "50px", height: "50px" }}
              />
            ) : (
              <i className="bi bi-buildings theme-color"></i>
            )}
          </div>
          <div className="feature-content">
            <div className="feature-title relative margin-bottom-10">
              <h5>{data?.heading || defaultHeadings[index]}</h5>
            </div>
            <div
              className="mb-0 text-center text-black"
              dangerouslySetInnerHTML={{ __html: combinedHTML }}
              onClick={(e) => {
                const target = e.target;
                if (target.tagName === "SPAN" && target.innerText === "Read More") {
                  handleReadMore(data);
                }
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
    <div className="container">
      {/* Desktop View */}
      <div className="home-intro-desktop mt-5">
        <div className="row">
          {principles.map((data, index) => (
            <div className="col-lg-4 pad-top-md-30" key={`desktop-${index}`}>
              {renderContentBox(data, index)}
            </div>
          ))}
        </div>
      </div>

      {/* Mobile View */}
      <div className="home-intro-mobile-view">
        <div className="row">
          <OwlCarousel
            className="service-main-wrapper"
            loop={true}
            nav={false}
            dots={false}
            autoplay={true}
            autoplayTimeout={2500}
            autoplayHoverPause={true}
            smartSpeed={1000}
            margin={30}
            responsive={{ 0: { items: 1 } }}
          >
            {principles.map((data, index) => (
              <div key={`mobile-${index}`} className="item">
                {renderContentBox(data, index, true)}
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>

      {/* Modal for full content */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedContent?.heading || "Details"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: selectedContent?.description || "No content available",
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-default" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
    </>
  );
}

export default MinimalIconVisionMissionValue;
